module.exports = __webpack_public_path__ + "assets/revive_icon_green.7e0e28f6dfddf4584cc552f16a8e36d8.svg";